import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  private setTotalBussyMB = new BehaviorSubject<any>(0);
  public totalBussyMB = this.setTotalBussyMB.asObservable();
  private setVideosLength = new BehaviorSubject<any>(0);
  public videosLength = this.setVideosLength.asObservable();

  constructor(private apiService: ApiService) {}

  public getAvailableMBDocuments(value) {
    this.setTotalBussyMB.next(value);
  }

  public getVideos(value) {
    this.setVideosLength.next(value);
  }

  public updateNavbarInfo() {
    var self = this;
    this.apiService.getNavbarInfo({}, {
      getResult(res) {
        self.setTotalBussyMB.next(res.data.totalBussyMB);
        self.setVideosLength.next(res.data.videos);
      },
      getError(err) {
        console.log(err);
      },
    });
  }
}
